module.exports = __webpack_public_path__ + "static/media/logoFirstHealth.e0084a0b.png";